import * as React from "react";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Select from "react-select";
import "./templateTabs.css";
import BalanceSheet from "./BalanceSheet";
import PnlStatement from "./PnlStatement";
import Pattern2 from "./Pattern2";
// import { filterOptionsData } from "../../Console/Component/services/mockHandler";
import { useSelector, useDispatch } from "react-redux";

import { getMappingDataApiHandler } from "../../services/api/apiHandler";
import { socket } from "../../services/socket/socket";
import swal from "sweetalert";

import buttoncss from "../../myfin_v2/css/button.module.css";
import commoncss from "../../myfin_v2/css/common.module.css";
import bookclosuretbcss from "../../myfin_v2/css/bookclosuretb.module.css";
import FSfilterDropdown from "../../myfin_v2/elements/FSfilterDropdown";


const shortcut = {
  color: "var(--clr-accent)",
  fontWeight: "600",
  fontSize: "1rem",
  marginLeft: "1rem",
  cursor: "pointer",
  borderRadius: "50%",
  border: "2px solid var(--clr-accent)",
  width: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const TemplateTabs = (props) => {
  // const {checkYearly, selectedRow} = useSelector((state)=> state.selectedDragReducer);
  const { setAddNoteGrp, onAfterDrop } = props;
  const [group, setGroup] = useState();
  const [rows, setRows] = useState([]);
  const [hideData, setHideData] = useState([]);
  const [hideChildData, sethideChildData] = useState([]);

  const [bsData, setBSData] = useState(null);
  const [plData, setPLData] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [selFilterData, setSelFilterData] = useState({});
  const [notes, setNotes] = useState([]);

  const [selectedL1, setSelectedL1] = useState(null);
  const [selectedL2, setSelectedL2] = useState(null);
  const [currentYear, setCurrentYear] = useState("");
  const [previousYear, setPreviousYear] = useState("");

  const dispatch = useDispatch()

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 0, height: "100%", display: "flex", flexDirection: "column" }}>
            <Typography component="div" style={{ height: "100%", display: "flex", flexDirection: "column" }}>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  const [value, setValue] = useState(0);
  const R_tb_id = useSelector((initialState) => initialState.reducer.tb_id);
  const LOCAL_tb_id = localStorage.getItem("tb_id");
  const project_id = localStorage.getItem("project_id");
  let tb_id = R_tb_id ? R_tb_id : LOCAL_tb_id;

  const [isHide, setHide] = useState(false);

 useEffect(() => {
  getMappingData();
}, [])

  useEffect(() => {
    const handleUpdate = () => {
      getMappingData();
    };

    // A mapping save requests BS, P&L, and grouping updates. The grouping
    // response is the single refresh needed for this table.
    socket.on("get-mapped-group-data", handleUpdate);

    return () => {
      socket.off("get-mapped-group-data", handleUpdate);
    };
  }, []);

  useEffect(() => {
    setRows([]);
    setHide(false);
  }, [value]);

  useEffect(() => {
    if (props.updateTabs !== undefined) {
      getMappingData();
    }
  }, [props.updateTabs]);

  function handleSelect(e) {
    if (e == null) {
      return;
    }
    
    // Check if it belongs to BS
    let foundL1 = bsData?.find(item => item._id === e.value[0]);
    let foundL2 = foundL1?.subgroup.find(sg => sg._id === e.value[1]);
    
    if (foundL1 && foundL2) {
      setValue(0);
      setSelFilterData(e);
      setSelectedL1(foundL1);
      setSelectedL2(foundL2);
    } else {
      // Check if it belongs to PL
      foundL1 = plData?.find(item => item._id === e.value[0]);
      foundL2 = foundL1?.subgroup.find(sg => sg._id === e.value[1]);
      
      if (foundL1 && foundL2) {
        setValue(1);
        setSelFilterData(e);
        setSelectedL1(foundL1);
        setSelectedL2(foundL2);
      }
    }

    if (props.onNoteSelect) props.onNoteSelect(e.label);
  }

  useEffect(() => {
    // setRows([])
    if (hideData.length > 0) {
      hideData.map((hidedata) => {
        delete rows[hidedata];
      });


    } else {
    }
  }, [isHide]);

  const handleEye = () => {
    if (isHide) {
      setHide(false);
      // fetchBalanceSheet();
    } else {
      setHide(true);
    }
  };

  const handleOptions = (o) => {
    setRows([]);
    setSelectedL1(null);
    setSelectedL2(null);
    setSelFilterData({});
    sessionStorage.removeItem("view");
    if (o === 0) {
      setValue(0);
    } else {
      setValue(1);
    }
  };


  useEffect(() => {
    setFilterData([]);
    // Only reset if it's not a programmatic selection (manual tab click)
    // Actually, it's safer to not reset here if we want to keep the highlight
    // But we need to build the combined filterData
    
    if (bsData || plData) {
      const bsL2Options = (bsData || []).flatMap(main =>
        main.subgroup.map(sub => ({
          label: sub.name,
          value: [main._id, sub._id],
          category: "BS"
        }))
      );

      const plL2Options = (plData || []).flatMap(main =>
        main.subgroup.map(sub => ({
          label: sub.name,
          value: [main._id, sub._id],
          category: "PL"
        }))
      );

      setFilterData([...bsL2Options, ...plL2Options]);
    }
  }, [bsData, plData])


 const getMappingData = async () => {
  sessionStorage.removeItem("bsGroupingData");
  sessionStorage.removeItem("plGroupingData");
  sessionStorage.removeItem("groupingData");

  const getParams = {
    projectID: project_id,
  };

  try {
    const response = await getMappingDataApiHandler(getParams);

    if (response?.data?.success === true) {
      const respData = response.data;

      setBSData(
        respData.grouping.filter(
          item => item.category === "BS"
        )
      );

      setPLData(
        respData.grouping.filter(
          item => item.category === "PL"
        )
      );
      setCurrentYear(respData.currentYear);
      setPreviousYear(respData.previousYear);

      return response;
    } else {
      swal(
        "Error",
        "Unable in getting mapping data",
        "error"
      );
    }
  } catch (error) {
    swal(
      "Error",
      "Unable in getting mapping data",
      "error"
    );
  }
};

  return (
    <div style={{ width: "100.5%", height: "100%", display: "flex", flexDirection: "column", gap: "5px" }}>
      <div className={`${bookclosuretbcss.tempNotesSection}  px-2 mb-1`}> 
        <FSfilterDropdown
          class_={commoncss.w70pct}
          class2_={buttoncss.greyBg2}
          options={filterData}
          selected={selFilterData}
          onSelect={(e) => {
            handleSelect(e);
          }}
          placeHolder={"Search for notes"}
        />

        <div className="button-group" style={{ "alignContent": "center" }}>
          <button
            className={`${buttoncss.custom_btn} ${value === 0 ? buttoncss.primary : buttoncss.secondary
              }`}
            style={{
              "borderRadius": "8.18px 0px 0px 8.18px",
              "padding": "5px",
              "minWidth": "50px",
   
              ...(value === 1 && { background: "#f5f5f5" }),
            }}
            onClick={(e) => {
              handleOptions(0);
              // setValue(0);
            }}
          >
            BS
          </button>
          <button
            className={`${buttoncss.custom_btn} ${value === 1 ? buttoncss.primary : buttoncss.secondary
              }`}
            style={{
              "borderRadius": "0 8.18px 8.18px 0",
              "padding": "5px",
              "minWidth": "50px",
              ...(value !== 1 && { background: "#f5f5f5" }),
            }}
            onClick={(e) => {
              handleOptions(1);
              // setValue(1);
            }}
          >
            P&L
          </button>
        </div>
      </div>
      <Box className="MuiBox-rootTab  px-2" sx={{ width: "100%", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <TabPanel value={value} index={0} style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <BalanceSheet
            setTempValue={setValue}
            setGroup={setGroup}
            // projectData={projectData}
            setHideData={setHideData}
            hideData={hideData}
            hideChildData={hideChildData}
            setAddNoteGrp={setAddNoteGrp}
            bsData={bsData}
            currentYear={currentYear}
            previousYear={previousYear}
            selectedL1 = {selectedL1}
            selectedL2 = {selectedL2}
            setExternalSelection={(l1, l2) => {
              setSelectedL1(l1);
              setSelectedL2(l2);
              if (!l1 && !l2) setSelFilterData({});
            }}
            setUpdateTabs={props.setUpdateTabs}
            refreshMappingData={getMappingData}
            onAfterDrop={onAfterDrop}
          />
        </TabPanel>
        <TabPanel value={value} index={1} style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <PnlStatement
            setTempValue={setValue}
            // projectData={projectData}
            setHideData={setHideData}
            hideData={hideData}
            hideChildData={hideChildData}
            setAddNoteGrp={setAddNoteGrp}
            plData={plData}
            currentYear={currentYear}
            previousYear={previousYear}
            selectedL1 = {selectedL1}
            selectedL2 = {selectedL2}
            setExternalSelection={(l1, l2) => {
              setSelectedL1(l1);
              setSelectedL2(l2);
              if (!l1 && !l2) setSelFilterData({});
            }}
            refreshMappingData={getMappingData}
            onAfterDrop={onAfterDrop}
          />
        </TabPanel>
      </Box>
    </div>
  );
};

export default TemplateTabs;
